export const PRODUCT_REQ_PENDNG = "PRODUCT_REQ_PENDNG"
export const PRODUCT_REQ_FAILURE = "PRODUCT_REQ_FAILURE"
export const PRODUCT_REQ_SUCESS= "PRODUCT_REQ_SUCESS"
export const FOR_RENDER= "FOR_RENDER"